'use client';

import animationData from '@/animations/use-case-omnichannel-escalations.json';
import Lottie, { LottieRefCurrentProps } from 'lottie-react';
import { FC, useEffect, useRef } from 'react';

export interface UseCaseOmnichannelEscalations {
  playing?: boolean;
}

const UseCaseAnimationEscalations: FC<UseCaseOmnichannelEscalations> = ({ playing }) => {
  const animationRef = useRef<LottieRefCurrentProps | null>(null);

  useEffect(() => {
    if (!animationRef.current) return;

    if (playing) {
      animationRef.current.play();
    } else {
      animationRef.current.pause();
    }
  }, [playing]);

  return (
    <div className="w-full aspect-[844/844]">
      <Lottie animationData={animationData} autoplay={false} lottieRef={animationRef} />
    </div>
  );
};

export default UseCaseAnimationEscalations;
